export default __webpack_public_path__ + "static/media/download.52214efb.svg";